var path = 'app/components/radniNalog/rnLink.html';
var html = "<a ui-sref=\"radniNalog.details({id:vm.rn.id})\" class=\"btn btn-xs\" ng-class=\"vm.style\"><span class=\"label\">{{vm.rn.sifra_naloga}}</span></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/radniNalog/rnLink.html
// module id = 631
// module chunks = 0